/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActuatorBuildInfo } from './actuatorBuildInfo';
import { ActuatorInfoVersion } from './actuatorInfoVersion';


/**
 * An endpoint which provides basic application configuration information. So a caller knows how the API is configured.
 */
export interface ActuatorInfo { 
    buildInfo?: ActuatorBuildInfo;
    app: ActuatorInfoVersion;
}

